import type { Engine } from '../types';
import { buildUrl } from '../url';

export const merriamWebster: Engine = {
  id: 'merriam-webster',
  name: 'Merriam-Webster',
  bang: 'mw',
  aliases: ['define', 'merriam'],
  homepage: 'https://www.merriam-webster.com',
  category: 'Reference',
  description: 'Definitions, or synonyms and antonyms from its thesaurus.',
  params: [
    {
      id: 'thesaurus',
      type: 'flag',
      token: 'syn',
      label: 'Thesaurus',
      group: 'Book',
      help: 'Synonyms and antonyms instead of the definition.',
    },
  ],
  build({ query, values }) {
    const book = values.thesaurus === true ? 'thesaurus' : 'dictionary';
    return `https://www.merriam-webster.com/${book}/${encodeURIComponent(query.trim())}`;
  },
};

// Google's codes, with the modifier where it differs (`.zh` for zh-CN).
const LANGUAGES: [code: string, token: string, label: string][] = [
  ['en', 'en', 'English'],
  ['es', 'es', 'Spanish'],
  ['fr', 'fr', 'French'],
  ['de', 'de', 'German'],
  ['it', 'it', 'Italian'],
  ['pt', 'pt', 'Portuguese'],
  ['nl', 'nl', 'Dutch'],
  ['sv', 'sv', 'Swedish'],
  ['pl', 'pl', 'Polish'],
  ['uk', 'uk', 'Ukrainian'],
  ['ru', 'ru', 'Russian'],
  ['el', 'el', 'Greek'],
  ['tr', 'tr', 'Turkish'],
  ['ar', 'ar', 'Arabic'],
  ['iw', 'he', 'Hebrew'],
  ['hi', 'hi', 'Hindi'],
  ['vi', 'vi', 'Vietnamese'],
  ['th', 'th', 'Thai'],
  ['id', 'id', 'Indonesian'],
  ['ja', 'ja', 'Japanese'],
  ['ko', 'ko', 'Korean'],
  ['zh-CN', 'zh', 'Chinese (Simplified)'],
  ['zh-TW', 'zht', 'Chinese (Traditional)'],
];

export const googleTranslate: Engine = {
  id: 'google-translate',
  name: 'Google Translate',
  bang: 'gt',
  aliases: ['translate'],
  homepage: 'https://translate.google.com',
  category: 'Reference',
  description:
    'Translates your words into English, or the language you pick (.es, .ja).',
  example: { query: 'good morning', mods: ['es'] },
  params: [
    {
      id: 'to',
      type: 'choice',
      label: 'Translate into',
      group: 'Language',
      help: 'The language it detects your words are in is left to Google.',
      options: LANGUAGES.map(([value, token, label]) => ({
        value,
        token,
        label,
      })),
    },
  ],
  build({ query, values }) {
    return buildUrl('https://translate.google.com/', {
      sl: 'auto',
      tl: (values.to as string | undefined) ?? 'en',
      text: query,
      op: 'translate',
    });
  },
};
